export const Languages = [
  { text: "简体中文", value: "cn" },
  { text: "English", value: "en" }
]

export const InterfaceUI = {
  "MOMO": {
    icon: require('../../assets/images/icon-mobile.png'),
    name: 'MOMO',
  },
  "BANK": {
    icon: require('../../assets/images/icon-card.png'),
    name: 'BANK',
  },
  "SPEI": {
    icon: require('../../assets/images/icon-card.png'),
    name: 'SPEI',
  },
  "CREDITCARD": {
    icon: require('../../assets/images/icon-card.png'),
    name: 'CREDITCARD',
  },
  "OVO": {
    icon: require('../../assets/images/icon-mobile.png'),
    name: 'OVO',
  },
  "DIRECT": {
    icon: require('../../assets/images/icon-bank.png'),
    name: 'DIRECT',
  },
  "QRIS": {
    icon: require('../../assets/images/icon-qrcode.png'),
    name: 'QRIS',
  },
  "DANA": {
    icon: require('../../assets/images/icon-other.png'),
    name: 'DANA',
  }
}

export const CoinMapCountry = {
  "UGX": {
    countryCode: "UG",
    areaCode: 256
  },
  "KES": {
    countryCode: "KE",
    areaCode: 254
  },
  "NGN": {
    countryCode: "NG",
    areaCode: 234
  },
  "USD": {
    countryCode: "US",
    areaCode: 1
  },
  "EUR": {
    countryCode: "",
    areaCode: 1
  },
  "GBP": {
    countryCode: "GB",
    areaCode: 44
  },
  "BRL": {
    countryCode: "BR",
    areaCode: 55
  },
  "IDR": {
    countryCode: "ID",
    areaCode: 62
  },
  "AED": {
    countryCode: "AE",
    areaCode: 971
  },
  "MXN": {
    countryCode: "MEX",
    areaCode: 52
  }
}

/**
 * 通过时区转换时间
 * @param date 时间
 * @param add 默认时间时区
 * @param fmt 格式化格式
 * @returns 
 */
export const FormatDateZone = (date: any, add = 8, fmt = 'YYYY-mm-dd HH:MM:SS') => {
  let ret
  if (!date) return date
  if (date == "Invalid Date") return "--"
  if (date == '0001-01-01 00:00:00') return '--'

  let isDate = date instanceof Date
  if (!isDate) {
    date = date.toString().replace(/-/g, '/')
    date = date.toString().replace("T", ' ')
    date = new Date(date)
  }

  let zone = 0 - new Date().getTimezoneOffset() / 60
  let t = date.getTime() + (zone - add) * 60 * 60 * 1000;   // 24小时 * 60分钟 * 60秒 * 1000
  date = new Date(t);

  const opt: any = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
  }

  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    };
  };
  return fmt
}

/**
 * 充值订单状态
 */
export const CashPayInOrderStatus = {
  "0": "processing",
  "1": "processing",
  "2": "success",
  "3": "fail",
  "4": "cancel"
}

/**
 * 提现订单状态
 */
export const CashPayOutOrderStatus = {
  "0": "processing",
  "1": "processing",
  "2": "processing",
  "3": "processing",
  "4": "processing",
  "5": "success",
  "6": "fail",
  "7": "reject",
  "8": "cancel"
}


/**
 * 计算充值步骤
 * @param channel PSP Code
 * @param paymentType 类型 MOMO BANK OVO...
 * @param coin 币种
 * @returns 步骤长度
 * 1：---> 下单
 * 2：填写表单 ---> 下单
 * 3：填写表单 ---> 调用校验 ---> 下单
 */
export const CalcPayInSteps = (channel: string, paymentType: string, coin: string) => {
  if (
    ['FacilitaPay'].includes(channel) ||
    ['DANA', 'QRIS'].includes(paymentType) ||
    (channel == 'AlchemyPay' && coin == 'MXN')
  ) {
    return [0]
  } else if (
    (['PivotPay'].includes(channel) && coin == 'KES') ||
    channel == 'AlchemyPay' ||
    ['CREDITCARD', "BANK", "SPEI"].includes(paymentType)
  ) {
    return [0, 0]
  } else {
    return [0, 0, 0]
  }
}

/**
 * 计算提现步骤
 * @param channel PSP Code
 * @param paymentType 类型 MOMO BANK OVO...
 * @param coin 币种
 * @returns 步骤长度
 * 1：---> 下单
 * 2：填写表单 ---> 下单
 * 3：填写表单 ---> 调用校验 ---> 下单
 */
export const CalcPayOutSteps = (channel: string, paymentType: string, coin: string) => {
  if (['OpenPay', 'FacilitaPay'].includes(channel)) {
    return [0]
  } else if (channel == 'AlchemyPay' || coin == 'KES' || ['CREDITCARD', "BANK", "SPEI"].includes(paymentType)) {
    return [0, 0]
  } else {
    return [0, 0, 0]
  }
}

/**
 * 业务表单数据
 */
export const FormData = {
  areaCode: "",
  countryCode: "",
  amount: 0,
  currency: "",
  channelCode: "",
  paymentType: "",
  supplier: "",
  phoneNumber: "",
  accountName: "",
  bankCode: "",
  bankName: "",
  bankNumber: "",
  reference: "",
  expiresIn: 0,

  expiryDate: '',
  cvv: "",

  accountType: "",
  channelName: "",
  channelIcon: "",
  paymentCode: "",
  qrCode: "",
  serviceFee: 0,
  transactionAmount: 0,
  creationAt: '',
  transactionFee: 0,
  thirdPlatformAmount: 0,

  orderNo: '',
  outOrderNo: '',
  orderStatus: -1,
  paymentUrl: '',
  cancelUrl: '',
  redirectUrl: '',
  checkoutUrl: "",
  vaNumber: "",
  extend: {
    orderNo: "",
    merchantNo: "",
    currency: "",
    responseCode: "",
    responseDescription: "",
    notifyUrl: "",
    checkoutUrl: "",
    syncNotifyUrl: "",
    iban: "",
    bic: "",
    qrCode: "",
    paymentCode: "",
    vaNumber: "",
  }
}

// 下拉框
export interface OptionObject {
  value: string
  name: string
}

// 支持的国家列表
export interface SupportedCountries {
  areaCode: string
  code: string
  flag: string
  name: string
  sortNumber: string
}

// PSP 对象
export interface ChannelObject {
  name: string // 名称
  code: string // 服务商编码
  icon: string // 图标
  cashChannelCurrencyRateSetting: Array<ChannelCurrencyRatesObject>
}

// 银行列表
export interface SupportedBanksList {
  bankCode: string
  bankName: string
}

// 币种方向费率配置
export interface ChannelCurrencyRatesObject {
  channelCostType: number
  channelCostTypeName: string
  channelId: string
  cost: number
  fixedCost: number
  taxRate: number
  currency: string
  formula: string
  deductionMethod: number
  flowDirection: number
  flowDirectionName: string
  id: string
  onedayAccountLimit: number
  onedayCountLimit: number
  singleAmountMaxLimit: number
  singleAmountMinLimit: number
  supportedChannelType: string
  supportedMobileType: string
  transactionFee: number
  supportedCountries: Array<SupportedCountries> // 支持的国家列表
  supportBanks: Array<SupportedBanksList> // 支持的银行列表
}

// 创建第三方支付订单
export interface CreateOrderParams {
  fundPassword?: string
  k?: string

  channel_code: string
  country_code?: string
  supplier?: string
  payment_type?: string

  account_name?: string
  phone_number?: string
  bank_code?: string
  bank_number?: string
}